/*============================================================================
  Sale-date cart discount sync — keep checkout discount aligned with cart lines.
==============================================================================*/

(function () {
  'use strict';

  var syncInProgress = false;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function normalizeCode(code) {
    return String(code || '').trim().toLowerCase();
  }

  function cartHasCode(cart, code) {
    if (!cart || !code) return false;
    var normalized = normalizeCode(code);
    if (!normalized) return false;

    if (cart.discount_codes && cart.discount_codes.length) {
      for (var i = 0; i < cart.discount_codes.length; i++) {
        var entry = cart.discount_codes[i];
        if (entry && normalizeCode(entry.code) === normalized) return true;
      }
    }

    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      for (var j = 0; j < cart.cart_level_discount_applications.length; j++) {
        var app = cart.cart_level_discount_applications[j];
        if (app && normalizeCode(app.title) === normalized) return true;
      }
    }

    return false;
  }

  function cartHasAnyDiscount(cart) {
    return !!(cart && (
      (cart.discount_codes && cart.discount_codes.length) ||
      (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length)
    ));
  }

  function collectCodesFromCartItems(items) {
    var codes = [];
    (items || []).forEach(function (item) {
      var props = item.properties || {};
      var code = props._wdSaleDiscountCode || props['_wdSaleDiscountCode'];
      if (code && String(code).trim()) codes.push(String(code).trim());
    });
    return codes;
  }

  function collectCodesFromDom() {
    var codes = [];
    document.querySelectorAll('[data-wd-is-sale-date="true"][data-wd-discount-code]').forEach(function (el) {
      var code = el.getAttribute('data-wd-discount-code');
      if (code && String(code).trim()) codes.push(String(code).trim());
    });
    return codes;
  }

  function resolveRequiredDiscountCode(cart) {
    var fromItems = collectCodesFromCartItems(cart.items);
    if (fromItems.length) return fromItems[0];
    return collectCodesFromDom()[0] || null;
  }

  function updateCartDiscount(code) {
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code || '' })
    });
  }

  function applyDiscountCode(code) {
    if (!code) return Promise.resolve(false);

    var root = cartRoot();
    return fetch(root + 'discount/' + encodeURIComponent(code), {
      credentials: 'same-origin'
    })
      .catch(function () { return null; })
      .then(function () {
        return updateCartDiscount(code);
      })
      .then(function (response) {
        return !!(response && response.ok);
      });
  }

  function refreshCartMarkup() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function syncCartSaleDiscount(options) {
    options = options || {};
    if (syncInProgress) return Promise.resolve(false);

    if (!options.force && typeof window !== 'undefined' && window.wdBundleCascadeInProgress) {
      return Promise.resolve(false);
    }

    syncInProgress = true;

    return fetch(cartRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!cart) return false;

        var requiredCode = resolveRequiredDiscountCode(cart);

        if (requiredCode) {
          if (cartHasCode(cart, requiredCode) || cartHasAnyDiscount(cart)) {
            return false;
          }
          return applyDiscountCode(requiredCode);
        }

        var cartEmpty = !cart.items || cart.items.length === 0;
        var domReady = !!document.querySelector('.cart__items .cart__item, #CartDrawer .cart__item');
        var noSaleMarkers = domReady && collectCodesFromDom().length === 0;

        if (cartHasAnyDiscount(cart) && (cartEmpty || noSaleMarkers)) {
          return updateCartDiscount('').then(function (response) {
            return !!(response && response.ok);
          });
        }

        return false;
      })
      .then(function (changed) {
        if (changed) refreshCartMarkup();
        return changed;
      })
      .catch(function () { return false; })
      .finally(function () {
        syncInProgress = false;
      });
  }

  window.wdSyncCartSaleDiscount = syncCartSaleDiscount;
  window.wdApplySaleDiscountCode = applyDiscountCode;

  if (document.body.classList.contains('template-cart')) {
    var boot = function () {
      syncCartSaleDiscount({ force: true });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  }
})();
